import React, { Component } from "react";
import PaymentService from "../services/payment.service";
import ParamsService from "../services/params.service";
import PaymentCustomerService from "../services/payment-customer.service";
import EventBus from "../common/EventBus";
import { Navigate }from "react-router-dom";
import ReactModal from 'react-modal';
import '../css/modal.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getDay, addDays, format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';
import axios from "axios";
import jwtDecode from "jwt-decode";
import logogaz from '../img/gaz.png';
import logoelec from '../img/elec.png';
import valide from '../img/check.png';
import etape from '../img/etape.png';
import logo from "../img/logo-ohm-Q.png";
import cb from "../img/cb.png";
import cb2 from "../img/cb2.png";
import bnp from "../img/bnp.png";
import x from "../img/x.png";
import bours from "../img/bours.png";
import ca from "../img/ca.png";
import banquerouge from "../img/banquerouge.png";
import sg from "../img/sg.png";
import autres from "../img/autres.png";
import master from "../img/master.png";
import visa from "../img/visa.png";
import authHeader from "../services/auth-header";
import Progressbar from "../common/progress_bar";
import loading from "../img/loading.gif";
import help from "../img/help.png";
import '../css/customer.css';
import AuthService from "../services/auth.service";
import {confirmAlert} from "react-confirm-alert";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
const tokentime = format(new Date(), "dd/MM/yyyy hh:mm:ss");
registerLocale('fr', fr);

const  cm = ParamsService.$_GET("cm");

const  from = ParamsService.$_GET("from");
const  check = ParamsService.$_GET("check");
var nbrEtal=1;
var amountDetteBackup=[-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1,-1];
var buckupContent = false;
const API_URL = process.env.REACT_APP_URL_API;
const USER_NAME_DEFAULT = process.env.REACT_APP_USER_NAME_DEFAULT;
const USER_PWD_DEFAULT = process.env.REACT_APP_USER_PWD_DEFAULT;

//Partie config mule
const API_URL_MULE = process.env.REACT_APP_URL_API_MULE;
const AUTHORIZATION_USERNAME = process.env.REACT_APP_URL_API_MULE_USERNAME;
const AUTHORIZATION_PASSWORD = process.env.REACT_APP_URL_API_MULE_PASSWORD;
const authToken = btoa(`${AUTHORIZATION_USERNAME}:${AUTHORIZATION_PASSWORD}`);

export default class Payment extends Component {

    blockRef0 = React.createRef();
    blockRef1 = React.createRef();
    constructor(props) {
        super(props);
        this.viewList = this.viewList.bind(this);
        this.scrollToBottom = this.scrollToBottom.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.infoPayment = this.infoPayment.bind(this);
        this.payment = this.payment.bind(this);
        this.transfer = this.transfer.bind(this);
        this.showBloc = this.showBloc.bind(this);
        this.loginDefault = this.loginDefault.bind(this);
        this.getContractsCustomer = this.getContractsCustomer.bind(this);
        this.handleOptionChangeTypePayment = this.handleOptionChangeTypePayment.bind(this);
        this.handleOptionChangeMethodEtalement = this.handleOptionChangeMethodEtalement.bind(this);
        this.handleOptionChangeMethodPayment = this.handleOptionChangeMethodPayment.bind(this);
        this.handleOptionChangeNbrEtalement = this.handleOptionChangeNbrEtalement.bind(this);
        this.handleOptionChangeInfoEtalement = this.handleOptionChangeInfoEtalement.bind(this);
        this.onChangeAmountUpdate = this.onChangeAmountUpdate.bind(this);
        this.reload = this.reload.bind(this);
        this.handleSelectInvoice = this.handleSelectInvoice.bind(this);
        this.requestEnedis = this.requestEnedis.bind(this);
        this.confirmationAction = this.confirmationAction.bind(this);
        this.confirmValidAction = this.confirmValidAction.bind(this);
        this.handleOptionChangeRetab = this.handleOptionChangeRetab.bind(this);
        this.onChangeTelEnedis = this.onChangeTelEnedis.bind(this);
        this.afficheDetailTab = this.afficheDetailTab.bind(this);
        this.afficheNbreEtal = this.afficheNbreEtal.bind(this);
        this.requestGrd = this.requestGrd.bind(this);
        this.confirmationActionGrdf = this.confirmationActionGrdf.bind(this);
        this.closePopupUpdateDate = this.closePopupUpdateDate.bind(this);
        this.updateDate = this.updateDate.bind(this);
        this.handleActionUpdateDate = this.handleActionUpdateDate.bind(this);

        this.state = {
            detailTab:false,
            displayBlock: false,
            block:"",
            loading:false,
            contracts: "",
            redirect: "",
            customer: "",
            isOpen: false,
            methodPayment: "",
            typePayment: "",
            typePaymentNv2: "",
            idDette:"",
            hostedTokenizationUrl:"",
            htmlContent:"",
            contract:null,
            dette:false,
            methodPaymentEtalement:"",
            nbrEtalement:1,
            firstDate:format(addDays(new Date(),7), "dd/MM/yyyy"),
            startDate:new Date(),
            messagerecovery:"",
            messagepayment:"",
            cm:"",
            user:"",
            token:"",
            processId:"",
            partialAmount:false,
            validePayment:"",
            refContract:"",
            indexDette:"",
            idDetteP:"",
            existDette:false,
            infoEtalement:"",
            parent:"",
            etape:0,
            nbMax:1,
            amountmaxupdate:"",
            amountUpdate:"",
            errorMsgUpdateAmount:"",
            valideMsgUpdateAmount:"",
            msgerrorurl:"",
            msgerrorcm:"",
            telContact:"",
            rechargePage:false,
            paymentType:false,
            backListInvoice:"",
            backListPayment:"",
            backPartialAmount:"",
            backupSpread:"",
            backupSpreadForceListAmount:"",
            backupSpreadForceListNbetal:"",
            backupSpreadForce:"",
            backupP0calc:"",
            listRefInvoiceAnticip:[],
            loadingAnticip:false,
            valFistEtal:0,
            infoEnedis:false,
            selectedOptionRetab:'oui',
            idProcessEnedis:false,
            retourEnedis:false,
            retourGrd:false,
            errorTelEnedis:false,
            dateEffet:new Date(),
            startDateUpdate:addDays(new Date(), 1),
            isUpdateDate:false,
            datePrel:"",
            invoiceAntDate:"",
            updateDateStatus:false,
            dateAnticipated:[],
            updateDateAnticipated:true,
            nbrDaysUpdate:20
        };


    }


    afficheNbreEtal(nbrEtalTotal, nbrEtalSelected) {
        let options = []
        for (let i = 1; i <= nbrEtalTotal; i++) {
            options.push(<option value={i} selected={i===nbrEtalSelected ? "true" : ""}>{i}</option>)
        }
        return options;
    }
    handleSelectInvoice(event){
        var contentAnticipeJs = JSON.parse(this.state.contracts);
        var listRefInvoiceAnticipJs = this.state.listRefInvoiceAnticip;
        var dettes = event.target.dataset.dettes;

        this.setState({loadingAnticip:true});
        if(this.state.listRefInvoiceAnticip.includes(event.target.value)){
            //console.log(event.target.dataset.contract);
            contentAnticipeJs[event.target.dataset.contract].dunning.actif = (contentAnticipeJs[event.target.dataset.contract].dunning.actif*1 - event.target.dataset.amount*1).toFixed(2);
            listRefInvoiceAnticipJs = listRefInvoiceAnticipJs.filter(item => item !== event.target.value);
            this.setState({listRefInvoiceAnticip : listRefInvoiceAnticipJs});
        }else{
            //console.log(event.target.dataset.contract);
            contentAnticipeJs[event.target.dataset.contract].dunning.actif = (contentAnticipeJs[event.target.dataset.contract].dunning.actif*1 + event.target.dataset.amount*1).toFixed(2);
            listRefInvoiceAnticipJs=listRefInvoiceAnticipJs.concat(event.target.value);
            this.setState({listRefInvoiceAnticip : listRefInvoiceAnticipJs});
        }
        this.setState({ infoEtalement: "", typePayment:"", methodPayment:"" , startDate:addDays(new Date(),7), firstdate:format(addDays(new Date(),7), "dd/MM/yyyy"), nbrEtalement:1});
        PaymentService.getInfoSpreadAnticipated(this.state.cm,
            contentAnticipeJs[event.target.dataset.contract].contractRef,
            contentAnticipeJs[event.target.dataset.contract].dunning.or,
            contentAnticipeJs[event.target.dataset.contract].dunning.invoice_list,
            listRefInvoiceAnticipJs, dettes).then(
            response => {
                contentAnticipeJs[event.target.dataset.contract].dunning.spread = response.data.spread;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_force_list_amount = response.data.spread_force_list_amount;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_force_list_nbetal = response.data.spread_force_list_nbetal;
                contentAnticipeJs[event.target.dataset.contract].dunning.spread_force = response.data.spread_force;
                contentAnticipeJs[event.target.dataset.contract].dunning.p0calc = response.data.p0calc;
                contentAnticipeJs[event.target.dataset.contract].dunning.partialAmount =response.data.partialAmount;
                this.setState({ contracts: JSON.stringify(contentAnticipeJs) });
                this.setState({ contract: contentAnticipeJs[event.target.dataset.contract] });
                this.setState({loadingAnticip:false});
                //console.log(response.data.partialAmount);
            },
            error => {
                console.log(error.response);
            }
        );

    }
    afficheDetailTab(){
        if(this.state.detailTab===false){
            this.setState({
                detailTab: true
            });
        }else{
            this.setState({
                detailTab: false
            });
        }
    }
    onChangeAmountUpdate(e) {
        let value = e.target.value *1;
        let amountTotal = e.target.dataset.amounttotal*1;
        let amountMin = e.target.dataset.amountmin*1;
        let minval = Math.min(amountMin,amountTotal).toFixed(2);
        this.setState({
            errorMsgUpdateAmount: "",
            valideMsgUpdateAmount: "",
            nbrEtalement:0,
            amountUpdate:""
        });
        localStorage.setItem("nbrEtalement",0);

        // Expression régulière pour valider le format float
        const floatRegex = /^-?\d*(\.\d+)?$/;

        // Vérification de la validit

        if (!floatRegex.test(value)) {
            this.setState({
                errorMsgUpdateAmount: "la valeur doit être un nombre avec 2 décimales maximum."
            });
        }else{
            if(value<minval){
                this.setState({
                    errorMsgUpdateAmount: "le montant minimum est "+minval+" euros."
                });
            }else{
                if(value>amountTotal){
                    this.setState({
                        errorMsgUpdateAmount: "le montant maximum est "+amountTotal+" euros."
                    });
                }else {
                    this.setState({
                        partialAmount: value,
                        amountUpdate:value,
                        valideMsgUpdateAmount: "Vous resterez redevable de "+(amountTotal-value).toFixed(2)+" euros."
                    });
                    localStorage.setItem("partialAmount",value);

                }
            }
        }

    }
    viewList(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ parent: index.target.dataset.parent });
    }

    transfer(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({loading:true});
        PaymentCustomerService.addPaymentCustomer(
            this.state.customer,
            JSON.stringify(this.state.contract),
            this.state.partialAmount,
            this.state.processId,
            "CUSTOMER_"+from,
            this.state.firstDate,
            this.state.nbrEtalement,
            this.state.methodPayment,
            this.state.methodPaymentEtalement,
            "",
            "",
            "",
            "LINK_CUSTOMER",
            null,
            this.state.listRefInvoiceAnticip,
            "0",
            null
            ).then(
                response => {
                    if(response.data.url){
                        if(from==="EC"){
                            window.open(response.data.url, "_blank");
                            this.setState({loading:false});
                            this.setState({rechargePage:true});
                        }else{
                            window.location.replace(response.data.url);
                        }

                    }else{
                        this.setState({loading:false});
                        this.setState({msgerrorurl:"Notre partenaire de paiement a rencontré un léger problème. Veuillez réessayer dans quelques secondes."})
                    }

                },
                error => {
                    this.setState({loading:false});
                    this.setState({msgerrorurl:"Notre partenaire de paiement a rencontré un léger problème. Veuillez réessayer dans quelques secondes."})
                }
            );

    }
    updateDate(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        const invoiceAntDate = JSON.parse(this.state.contracts)[index.target.dataset.contract].anticipated.invoice[0];
        const str = index.target.dataset.dateprelev; // "10/01/2026"
        const [dd, mm, yyyy] = str.split("/").map(Number);
        const datePrel = new Date(yyyy, mm - 1, dd);

        this.setState({ nbrDaysUpdate:JSON.parse(this.state.contracts)[index.target.dataset.contract].anticipated.infospread.spread.delai_max_choix_prelev, block:index.target.dataset.contract, isUpdateDate: true, datePrel: datePrel, invoiceAntDate: invoiceAntDate, updateDateStatus: true});
    }
    handleActionUpdateDate(e){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({loading:true})
        e.preventDefault();
        this.form.validateAll();
        if (this.checkBtn.context._errors.length === 0) {
            PaymentCustomerService.updateDateInvoice(
                JSON.stringify(this.state.invoiceAntDate),
                format(new Date(this.state.startDateUpdate), "dd/MM/yyyy")
            ).then(
                response => {
                    this.setState({
                        message: (<>La date est bien modifée.</>),
                        classmessage: "success ",
                        loading: false,
                        updateDateStatus: false,
                        updateDateAnticipated: false,
                        dateAnticipated: {[this.state.block]: "Prochain prélèvement pour le "+format(new Date(this.state.startDateUpdate), "dd/MM/yyyy" )}
                    });

                },
                error => {
                    this.setState({
                        message: "Il y'a un probléme technique merci de contacter le support technique.",
                        classmessage: "error",
                        loading: false,
                        updateDateStatus: false

                    });
                }
            );
        }

    }
    closePopupUpdateDate(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({isUpdateDate:false, sendWith:"-", sendLink: true});
    }
    payment(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        PaymentService.getIframeWorldline().then(
            response => {
                this.setState({
                    hostedTokenizationUrl: response.data.hostedTokenizationUrl,
                    hostedTokenizationId: response.data.hostedTokenizationId
                });
                localStorage.setItem("hostedTokenizationUrl", response.data.hostedTokenizationUrl);
                localStorage.setItem("API_URL", API_URL);
                localStorage.setItem("contract", JSON.stringify(this.state.contract));
                localStorage.setItem("customer", this.state.customer);
                localStorage.setItem("methodPaiment", this.state.methodPayment);
                localStorage.setItem("methodPaymentSpread", this.state.methodPaymentEtalement);
                localStorage.setItem("firstDate", this.state.firstDate);
                localStorage.setItem("processId", this.state.processId);
                localStorage.setItem("token", this.state.token);
                localStorage.setItem("nbrEtalement", this.state.nbrEtalement);
                localStorage.setItem("partialAmount", this.state.partialAmount);
                localStorage.setItem("listRefInvoiceAnticip", this.state.listRefInvoiceAnticip);
                localStorage.setItem("messagePayment",this.state.messagepayment);

            },
            error => {
                this.setState({
                    contracts:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
        this.setState({ isOpen: true });


    }


    loginDefault(cm) {
        var path="login_check";
        var uri = API_URL;
        if(process.env.REACT_APP_MULE==="1") {
            axios.defaults.headers.common['Authorization'] = `Basic ${authToken}`;
            path = "login";
            uri = API_URL_MULE;
        }

        return axios
            .post(uri + path, {
                "username":USER_NAME_DEFAULT,
                "password":USER_PWD_DEFAULT
            }, { mode: 'cors', credentials: 'include' })
            .then(response => {
                if (response.data.token) {
                    const token = response.data.token;
                    let user = [];
                    user = jwtDecode(token);
                    user['useremail'] = response.data.email;
                    user['userid'] =  response.data.user_id;
                    user['role'] = response.data.roles;
                    this.setState({
                        user:user,
                        token:token
                    });
                    localStorage.setItem("token",token);
                    localStorage.setItem("user", JSON.stringify(user));
                    this.setState({etape:this.state.etape+20});
                    this.getContractsCustomer(cm, token);
                }
            });
    }

    getContractsCustomer(cm, token) {
        return axios.get(
            API_URL + 'haugazel/contracts_customer_token/' + cm,
            { headers: {
                        Authorization: 'Bearer ' + token
                }
            })
            .then(response => {
                if (response.data && !response.data.error) {
                    const  contracts= JSON.stringify(response.data.contracts);
                    const  customer= JSON.stringify(response.data.customer);
                    const  messagerecovery= JSON.stringify(response.data.messagerecovery);
                    const  messagepayment= response.data.messagepayment;
                    let refcm = response.data.customer.refCustomer;
                    this.setState({telContact:(refcm[0] + refcm[1] === "CM" ? "09 70 70 21 25" : (refcm[0] + refcm[1] === "PM" ? "01 76 49 71 84" : "01 82 88 40 54"))});
                    this.setState({
                        contracts:contracts,
                        customer:customer,
                        messagerecovery: messagerecovery,
                        messagepayment:messagepayment,
                        etape:this.state.etape+70
                    })

                }else{
                    if(response.data.error){
                        this.setState({
                                msgerrorcm: response.data.error
                            }
                        )
                }
                }

                return response.data;
            });

    }


    showBloc(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        var contentAnticipe = JSON.parse(this.state.contracts);

        if(buckupContent===false){
            buckupContent = this.state.contracts;
        }



        if(index.target.dataset.type==="anticipe") {
            this.setState({paymentType: "anticipe"});
            this.setState({listRefInvoiceAnticip: contentAnticipe[index.target.dataset.contract].anticipated.refInvoice});
            if(amountDetteBackup[index.target.dataset.contract]===-1) {
                amountDetteBackup[index.target.dataset.contract] = contentAnticipe[index.target.dataset.contract].dunning.actif;
            }
            contentAnticipe[index.target.dataset.contract].dunning.actif = contentAnticipe[index.target.dataset.contract].anticipated.sumAmountInvoice;
            contentAnticipe[index.target.dataset.contract].dunning.invoice_list = contentAnticipe[index.target.dataset.contract].anticipated.invoice;
            contentAnticipe[index.target.dataset.contract].dunning.payment_list = [];
            contentAnticipe[index.target.dataset.contract].dunning.partialAmount = contentAnticipe[index.target.dataset.contract].anticipated.infospread.partialAmount;

            contentAnticipe[index.target.dataset.contract].dunning.spread = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force_list_amount = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force_list_amount;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force_list_nbetal = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force_list_nbetal;
            contentAnticipe[index.target.dataset.contract].dunning.spread_payment_force = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force;
            contentAnticipe[index.target.dataset.contract].dunning.spread_force = contentAnticipe[index.target.dataset.contract].anticipated.infospread.spread_force;
            contentAnticipe[index.target.dataset.contract].dunning.p0calc = contentAnticipe[index.target.dataset.contract].anticipated.infospread.p0calc;
            this.setState({ contracts: JSON.stringify(contentAnticipe) });
        }else{
            this.setState({paymentType: "dettes"});
            this.setState({listRefInvoiceAnticip: ""});
            this.setState({ contracts: buckupContent });
        }

        localStorage.setItem("VALIDE_PAYMENT","NOK");
        localStorage.setItem("pp1",0);
        this.setState({ indexDette: index.target.dataset.contract});
        this.setState({ infoEnedis: false });
        this.setState({ idDette: index.target.dataset.id ,block:(index.target.dataset.contract*1===0 ? this.blockRef0 : this.blockRef1)});
        this.setState({ infoEtalement: "", typePayment:"", methodPayment:"" , startDate:addDays(new Date(),7),firstdate:format(addDays(new Date(),7), "dd/MM/yyyy"), nbrEtalement:1});
        this.setState({ contract: index.target.dataset.type==="anticipe" ? contentAnticipe[index.target.dataset.contract] :  JSON.parse(buckupContent)[index.target.dataset.contract]});
        this.setState({ idDetteP: "" })
        this.setState({ displayBlock: true });
        PaymentService.startProcess(
            JSON.parse(this.state.contracts)[index.target.dataset.contract],
            this.state.customer,
            this.state.user["userid"],
            (ParamsService.$_GET("from")!=="" ? "CUSTOMER_"+ParamsService.$_GET("from") : "CUSTOMER"),
            0,
            "",
            index.target.dataset.type==="anticipe" ? 1 : 0
        ).then(
            response => {
                this.setState({processId:response.data})
            },
            error => {
                this.setState({
                    contracts:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.displayBlock) {
            this.scrollToBottom(this.state.block);
            this.setState({ displayBlock: false });
        }
        if (this.state.infoEnedis) {
            this.scrollToBottom(this.state.block);
        }
    }

    handleOptionChangeInfoEtalement(e){
        nbrEtal = e.target.options[e.target.selectedIndex].dataset.nbrmax;
        this.setState({
            partialAmount:e.target.value,
            nbMax:e.target.options[e.target.selectedIndex].dataset.nbrmax,
            nbrEtalement:1
        });
        localStorage.setItem("nbrEtalement",1);

        this.infoPayment(this.state.customer, this.state.contract, localStorage.getItem("nbrEtalement") ? localStorage.getItem("nbrEtalement") : 1 , e.target.value, format(this.state.startDate,"dd/MM/yyyy"), this.state.listRefInvoiceAnticip).then(
            response => {

                this.setState({
                    infoEtalement: JSON.stringify(response.data),
                   valFistEtal:response.data[2].amount
                });

            });
    }

    handleOptionChangeTypePayment(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }

        if(index.target.dataset.val!==this.state.typePayment) {
            this.setState({partialAmount: index.target.dataset.partialamount});
            nbrEtal = index.target.dataset.nbretal;
            localStorage.setItem("partialAmount", index.target.dataset.partialamount);

            this.setState({methodPayment: index.target.dataset.methodpayment});
            this.setState({typePayment: index.target.dataset.val});
            this.setState({infoEtalement: ""});
            this.setState({methodPaymentEtalement: "cb"});


            if (index.target.dataset.val === "pic" || index.target.dataset.val === "picvir") {
                this.setState({nbrEtalement: 0});
                localStorage.setItem("nbrEtalement", 0);
            } else {
                this.setState({nbrEtalement: 1});
                localStorage.setItem("nbrEtalement", 1);
            }

            this.setState({amountUpdate: ""});
            this.setState({valideMsgUpdateAmount: ""});
        }
    }
    handleOptionChangeNbrEtalement(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ nbrEtalement: index.target.value, parent:"" });
        localStorage.setItem("nbrEtalement", index.target.value);
        this.infoPayment(this.state.customer, this.state.contract, index.target.value, this.state.partialAmount, format(this.state.startDate,"dd/MM/yyyy"),this.state.listRefInvoiceAnticip).then(
            response => {

                this.setState({
                    infoEtalement: JSON.stringify(response.data),
                    valFistEtal:response.data[2].amount
                });

            });
    }


    handleOptionChangeMethodEtalement(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ methodPaymentEtalement: index.target.dataset.val });

    }

    handleOptionChangeMethodPayment(index){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        this.setState({ methodPaymentEtalement: "" });
        this.setState({ methodPayment: index.target.dataset.methodpayment });
    }


    infoPayment(customer, contract, nbrEtallement, partialPayment, firstDateEtalement,listFilterInvoice){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        return axios.post(API_URL + "payment/info", {
            customer,
            contract,
            nbrEtallement,
            partialPayment,
            firstDateEtalement,
            listFilterInvoice
        },{ headers: authHeader() });
    }
    closePopup(){
        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.reload();
        }
        /*
        if(localStorage.getItem("VALIDE_PAYMENT")==="OK"){
            this.setState({
                loading:true
            });
            let updateContacts = JSON.parse(this.state.contracts);
            this.setState({idDetteP:this.state.idDette});
            this.setState({idDette:-1});
            if(updateContacts[this.state.indexDette].dunning.actif-this.state.amountUpdate>=0) {
                OdooService.getContractsCustomer(this.state.cm).then(
                    () => {
                        this.setState({
                            successful: true,
                            nextPage: "/info_payment",
                            loading:false,
                            contracts: localStorage.getItem("contracts")
                        });
                        this.setState({isOpen:false});
                    },
                    error => {
                        const resMessage =
                            (error.response &&
                                error.response.data &&
                                error.response.data.message) ||
                            error.message ||
                            error.toString();

                        this.setState({
                            loading: false,
                            message: resMessage
                        });
                    }
                );
            }
        }else{
            this.setState({isOpen:false});
        }
        */
        this.setState({isOpen:false});
        window.location.reload();

    }
    onChangeTelEnedis(e) {

        if(tokentime !== localStorage.getItem("tokentime")){
            window.location.replace("/create_payment");
        }
        this.setState({
            tel: e.target.value
        });
        if(!e.target.value) {
            this.setState({
                errorTelEnedis: "Ce champ est obligatoire."
            });
        }else {
            const PHONE_REGEX = new RegExp(
                '^(?:(?:\\+|00)33[\\s.-]{0,3}(?:\\(0\\)[\\s.-]{0,3})?|0)[1-9](?:(?:[\\s.-]?\\d{2}){4}|\\d{2}(?:[\\s.-]?\\d{3}){2})$'
            );
            let resValidation = PHONE_REGEX.test(e.target.value);

            if (!resValidation) {
                this.setState({
                    errorTelEnedis: "Numéro de téléphone non valide."
                });
            }else{
                this.setState({
                    errorTelEnedis:false
                });
            }
        }

    }
    handleOptionChangeRetab(e){
        this.setState({
            selectedOptionRetab: e.target.value,
        });
        if(e.target.value==='oui'){
            this.setState({
                dateEffet: new Date(),
            });
        }

        if(e.target.value==='non'){
            this.setState({
                dateEffet: addDays(new Date(),1),
            });
        }


    }

    confirmValidActionGrdf(processId){
        this.setState({loading:true})
        PaymentService.executProcessGrdf(
            processId
        ).then(
            response => {
                this.setState({retourGrd: response.data,loading:false});
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }

    confirmValidAction(processId){
        this.setState({loading:true})
        PaymentService.executProcessEnedis(
            processId
        ).then(
            response => {
                this.setState({retourEnedis: response.data,loading:false});
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }
    confirmationAction() {
        PaymentService.updateProcessEnedis(this.state.idProcessEnedis,this.state.tel.replace(/\s/g,''), format(new Date(this.state.dateEffet), "yyyy-MM-dd"));
        confirmAlert({
            title: 'Confirmation',
            message: 'Voulez-vous vraiment valider cette action ?',
            buttons: [
                {
                    label: 'Oui',
                    onClick: () => this.confirmValidAction(this.state.idProcessEnedis)
                },
                {
                    label: 'Non',
                    onClick: () => this.setState({loading:false})
                }
            ]
        });
    }

    confirmationActionGrdf() {
        PaymentService.updateProcessGrdf(this.state.idProcessGrdf,this.state.tel.replace(/\s/g,''), format(new Date(this.state.dateEffet), "yyyy-MM-dd"));
        confirmAlert({
            title: 'Confirmation',
            message: 'Voulez-vous vraiment valider cette action ?',
            buttons: [
                {
                    label: 'Oui',
                    onClick: () => this.confirmValidActionGrdf(this.state.idProcessGrdf)
                },
                {
                    label: 'Non',
                    onClick: () => this.setState({loading:false})
                }
            ]
        });
    }
    requestGrd(index){
        let info = JSON.parse(this.state.customer);
        let numtel = info.tel;
        PaymentService.startProcessGrd(
            this.state.customer,
            JSON.parse(this.state.contracts)[index.target.dataset.contract],
            AuthService.getCurrentUser().userid,
            index.target.dataset.request,
            index.target.dataset.typerequest,
            localStorage.getItem("origine"),
            index.target.dataset.pce
        ).then(
            response => {
                this.setState({
                    infoGrd:true,
                    infoEnedis:false,
                    idDette:index.target.dataset.id,
                    tel:numtel,
                    idProcessGrdf:response.data,
                    block:(index.target.dataset.contract*1===0 ? this.blockRef0 : this.blockRef1)
                })
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }
    requestEnedis(index){
        let info = JSON.parse(this.state.customer);
        let numtel = info.tel;

        PaymentService.startProcessEnedis(
            this.state.customer,
            JSON.parse(this.state.contracts)[index.target.dataset.contract],
            AuthService.getCurrentUser().userid,
            index.target.dataset.request,
            index.target.dataset.typerequest,
            localStorage.getItem("origine"),
            index.target.dataset.pce
        ).then(
            response => {
                this.setState({
                    infoEnedis:true,
                    idDette:index.target.dataset.id,
                    tel:numtel,
                    idProcessEnedis:response.data,
                    block:(index.target.dataset.contract*1===0 ? this.blockRef0 : this.blockRef1)
                })
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );

    }
    reload(){
        window.location.reload();
    }
    scrollToBottom = (block) => {
        block.current.scrollIntoView({ behavior: 'smooth' });
    };
    componentDidMount() {
        localStorage.removeItem("user");
        localStorage.removeItem("contracts");
        localStorage.removeItem("contract");
        localStorage.removeItem("customer");
        localStorage.removeItem("messagePayment");
        localStorage.setItem("tokentime", tokentime);
        buckupContent = false;
        if(!check || check*1===0){
            window.location.replace("/confirmation/&cm="+cm+"&from="+from);
        }

        if(cm){
            this.setState({cm: cm});
            this.loginDefault(cm);
        }

        this.setState({ partialAmount: false });
        this.setState({ validePayment: "NOK" });
        localStorage.setItem("nbrEtalement", 1);
        localStorage.setItem("origine","CUSTOMER");
        this.setState({idDetteP: ""});
        localStorage.setItem("firstDate", format(addDays(new Date(),7), "dd/MM/yyyy"));
    }


    render() {
        const heureActuelle = new Date();
        const heureLimite = new Date();
        const heureLimiteCancel = new Date();
        const heureLimiteCancelGrdf = new Date();
        const heureLimiteCancel2Grdf = new Date();
        heureLimite.setHours(14, 50, 0, 0);
        heureLimiteCancel.setHours(16, 50, 0, 0);
        heureLimiteCancelGrdf.setHours(15, 0, 0, 0);
        heureLimiteCancel2Grdf.setHours(21, 0, 0, 0);
        const estAvantLimite = heureActuelle <= heureLimite;
        const estAvantLimiteCancel = heureActuelle <= heureLimiteCancel;
        const estAvantLimiteCancelGrdf = heureActuelle <= heureLimiteCancelGrdf;
        const estAvantLimiteCancel2Grdf = heureActuelle <= heureLimiteCancel2Grdf;

        const handleDateUpdate = (date) => {
            this.setState({startDateUpdate: date, firstDate:format(date, "dd/MM/yyyy"), parent:""});
        };

        const handleDateChangeEnedis = (date) => {
            this.setState({dateEffet: date});

        };
        const handleDateChange = (date) => {
            this.setState({startDate: date, firstDate:format(date, "dd/MM/yyyy"), parent:""});
            localStorage.setItem("firstDate", format(date, "dd/MM/yyyy"));
            this.infoPayment(this.state.customer, this.state.contract, this.state.nbrEtalement, this.state.partialAmount, format(date, "dd/MM/yyyy"),this.state.listRefInvoiceAnticip).then(
                response => {

                    this.setState({
                        infoEtalement: JSON.stringify(response.data),
                       valFistEtal:response.data[2].amount
                    });

                });
        };


        const isWeekday = (date) => {
            const day = getDay(date);
            return day !== 0 && day !== 6;
        };
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }
        let items  = [];
        if(this.state.contracts){
            items = JSON.parse(this.state.contracts);
        }
        let customer = "";
        if(this.state.customer){
            customer = JSON.parse(this.state.customer);
        }

        let infoEtalementTab = [];
        if(this.state.infoEtalement){
            infoEtalementTab = JSON.parse(this.state.infoEtalement);
        }


        if(this.state.msgerrorcm){
           return(
            <div className="col-md-12">
                <header className="jumbotron">
                    <h3>{this.state.msgerrorcm}.</h3>
                </header>
            </div>);
        }

        return (

            <div className="col-12">
                { (this.state.customer==="") &&
                    <header className="jumbotron">
                        <Progressbar bgcolor="#30ad71" progress={this.state.etape}  height={30} />
                    </header>
                }
                { (this.state.customer!=="") &&
                <header className="jumbotron">
                    <div className="circle-container circle-customer">
                        <div className="circle-text">
                            {customer.firstname[0] + customer.lastname[0]}
                        </div>
                    </div>
                    <span className="name">
                        { customer.firstname + " " + customer.lastname }
                    </span>
                    <div className="trait"></div>
                    <span className="cm">
                        {customer.refCustomer}
                    </span>
                </header>

                }
                { (this.state.contracts!=="") &&

                <div className="App">
                    {items.map((val, key) => {
                        if(this.state.existDette===false && val.dunning.actif>0) {
                            this.setState({existDette: true});
                        }

                        return (
                            <div className="row row-payment"  key={val.id}>
                                <div className="col-12 block-info-payment" >
                                    <div className="col-12 info-payment">
                                        <div className="row">
                                            <div className="col-12 status-contract">
                                                <span className={"label-status "+(val.statuscontract==="Terminé ✓" ? "label-contract status-termine" : (val.statuscontract!=="En attente de paiement" ? "orange" : ""))}>{this.state.dateAnticipated[key] ?? val.statuscontract}</span>
                                            </div>

                                        </div>

                                        <div className="row detail-contract">
                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                <span className="title-bloc">Contrat & adresse :</span>
                                                <span className="titre-contract">{val.contractRef}</span>
                                                <span className="label-contract">{val.adress}</span>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                <div className="row col-12">
                                                    <span className="title-bloc">Type d’énergie</span>
                                                </div>
                                                <div className="row col-12">
                                                    <div className="circle-energy circle-contract col-2">
                                                        <img className="logotypecontact" alt={"Type contrat"}
                                                         src={val.energyType==="EL" ? logoelec : (val.energyType==="NG" ? logogaz : logo)}/>
                                                    </div>
                                                    <div className="col-10 info-type-contract">
                                                        <span className="titre-contract">
                                                        {val.energyType==="EL" ? "Electricité" : (val.energyType==="NG" ? "GAZ Naturel" : val.energyType)}
                                                        </span>
                                                        <span className="label-contract">Statut du contrat : <b>{val.status}</b></span>
                                                        {(val.energyType==="EL" && val.enedis && val.enedis.body.onGoingInterventions.libelle) &&
                                                            <span className="label-contract">Type compteur : <b>{val.enedis.body.onGoingInterventions.openingLevel*1===2 ? "Communiquant":"Non communiquant" }</b></span>
                                                        }
                                                        {(val.energyType==="EL" && val.enedis && val.enedis.body.onGoingInterventions.situationAlimentation) &&
                                                            <span className="label-contract">Etat du point : <b>{val.enedis.body.onGoingInterventions.situationAlimentation }</b></span>
                                                        }
                                                        {(val.energyType==="NG" && val.grd && val.grd.statusGaz) &&
                                                            <span className={"label-contract"}>Etat du point : <b className={"label-contract "+(val.grd.statusGaz==="Coupé" ? "info" : "")}>{val.grd.statusGaz}</b></span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div>
                                            <hr className="ligne-grise"/>
                                        </div>

                                        <div className={"row detail-contract " + (this.state.paymentType==="dettes" ? "detail-contract-selected" : "")}>
                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                <span className="titre-paiement">Paiement de vos dettes :</span>
                                                <span className="titre-contract">DETTES :<b className="info"> {amountDetteBackup[key] > -1 ? amountDetteBackup[key].toFixed(2) : val.dunning.actif.toFixed(2)}&euro;</b></span>
                                                {(val.dunning.paused>0)&&
                                                    <span className="titre-contract">DETTES EN PAUSE :<b className="info">{val.dunning.paused.toFixed(2)}&euro;</b></span>
                                                }
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                <span className="title-bloc">STATUT</span>
                                                <div className="paiement-status">
                                                    { ((val.dunning.actif > 0 && amountDetteBackup[key]===-1) || amountDetteBackup[key]>0) ?
                                                    <span className="label-status">En attente de paiement</span>:
                                                    <span className="label-status label-contract status-termine"><b>Terminé ✓</b></span>
                                                    }
                                                </div>

                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail bloc-btn-paiement">
                                                <span className="title-bloc"><br/></span>
                                                { ((val.dunning.actif > 0 && amountDetteBackup[key]===-1) || amountDetteBackup[key]>0) ?
                                                <button data-id={val.id} data-contract={key} onClick={this.showBloc} className="btn-dette-v2">Régulariser votre situation</button> :
                                                    <button className="btn-dette-v2 label-contract status-termine"><b>Tout est en ordre!</b></button>
                                                }
                                            </div>
                                        </div>
                                        {((val.anticipated.sumAmountInvoice > 0) && (val.status==="Terminé" || val.status==="Actif")) &&
                                            <div>
                                                <hr className="ligne-grise"/>
                                            </div>
                                        }
                                        {((val.anticipated.sumAmountInvoice > 0) && (val.status==="Terminé" || val.status==="Actif")) &&
                                        <div className={"row detail-contract " + (this.state.paymentType==="anticipe" ? "detail-contract-selected" : "")}>
                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                <span className="titre-paiement">factures en cours :</span>
                                                <span className="titre-contract">MONTANT :<b className="info"> {val.anticipated.sumAmountInvoice.toFixed(2)}&euro;</b></span>

                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                <span className="title-bloc">STATUT</span>
                                                <div className="paiement-status">
                                                    { (val.anticipated.sumAmountInvoice>0) ?
                                                        <span  className="label-status"><span>{this.state.dateAnticipated[key] ?? val.anticipated.status}</span><br/>
                                                            { this.state.updateDateAnticipated ?
                                                                <button data-type="anticipe" id={"bloc"+val.id} data-status = {val.anticipated.status} data-id={val.id} data-dateprelev={val.anticipated.invoice[0].invoice_date_due} data-contract={key} onClick={this.updateDate} className="btn-dette-v2">Modifier la date</button> : <></> }</span>
                                                        :
                                                        <span className="label-status label-contract status-termine"><b>Terminé ✓</b></span>
                                                    }
                                                </div>

                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail bloc-btn-paiement">
                                                <span className="title-bloc"><br/></span>
                                                { (val.anticipated.sumAmountInvoice>0) ?
                                                    (
                                                        <div className="tooltipanticipe">
                                                            { this.state.updateDateAnticipated ?
                                                                <button data-type="anticipe" id={"bloc"+val.id} data-id={val.id} data-contract={key} onClick={this.showBloc} className="btn-dette-v2">Régler de manière anticipée</button> : <></>
                                                            }
                                                            <span className="tooltiptextanticipe col-12">{"Vous pouvez payer vos factures à venir, par carte bancaire ou directement avec votre banque. Si le montant est important vous pouvez mettre en place un étalement dès aujourd’hui. Si la totalité du montant dû n’est ni payée, ni étalée, alors elle sera prélevée à la date d'échéance comme convenu."}</span>
                                                        </div>
                                                    ) :
                                                    <button className="btn-dette-v2 label-contract status-termine"><b>Tout est en ordre!</b></button>
                                                }
                                            </div>
                                        </div>
                                        }
                                        {(val.energyType==="EL" && val.enedis && val.enedis.body.onGoingInterventions.libelle && val.dunning.spread.retablissement_client*1!==0) &&

                                        <div>
                                            <hr className="ligne-grise"/>
                                        </div>
                                        }
                                        {(val.energyType==="EL" && val.enedis && val.enedis.body.onGoingInterventions.libelle && val.dunning.spread.retablissement_client*1!==0 && val.enedis.body.onGoingInterventions.contractualState!=="RESIL") &&
                                        <div className={"row detail-contract " + (this.state.infoEnedis===true ? "detail-contract-selected" : "")}>
                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                <span className="titre-paiement">Demande en cours auprès d'Enedis :</span>
                                                <span className="titre-contract">{val.enedis.body.onGoingInterventions.libellePers} <b className="info">{ val.enedis.body.onGoingInterventions.dateEffetCalc}</b></span>


                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                <span className="title-bloc">STATUT</span>
                                                <div className="paiement-status">
                                                    { ((val.dunning.actif > 0 && amountDetteBackup[key]===-1) || amountDetteBackup[key]>0) ?
                                                        <span className="label-status"> {(customer.en ==="msgAll") ? <span><b>Les dettes de tous les contrats doivent être soldées</b></span> :  <span><b>Les dettes du contrat doivent être soldées</b></span>}</span>:
                                                        <span className="label-status label-contract status-termine"><b>Demande d'annulation ou de rétablissement autorisée ✓</b></span>
                                                    }
                                                </div>

                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12 linge-detail bloc-btn-paiement">
                                                <span className="title-bloc"><br/></span>
                                                { ((val.enedis.body.onGoingInterventions.situationAlimentation==="Coupé" || val.enedis.body.onGoingInterventions.situationAlimentation==="Limité" ) && val.enedis.body.onGoingInterventions.codeDemande==="F200BO3") ?
                                                    (
                                                        <div className="tooltipanticipe">
                                                            <button className="btn-dette-v2 label-contract status-termine"><b>Demande d'annulation ou de rétablissement est bien effectuée!</b></button>

                                                        </div>
                                                    ) :
                                                    (val.dunning.en==="btn" || customer.en==="btn") ?
                                                        <button id={"bloc"+val.id}
                                                                disabled={this.state.retourEnedis===false ? false : true}
                                                                data-request={val.enedis.body.onGoingInterventions.affaireId}
                                                                data-typerequest={val.enedis.body.onGoingInterventions.typeRequest}
                                                                data-id={val.id} data-contract={key}
                                                                data-pce={val.enedis.body.onGoingInterventions.pointId}
                                                                onClick={this.requestEnedis} className="btn-dette-v2">{val.enedis.body.onGoingInterventions.libelleBoutton}</button> :
                                                        <button className="btn-dette-v2 btn-disabled" disabled={true}>
                                                            <span>{val.enedis.body.onGoingInterventions.libelleBoutton}</span>
                                                        </button>

                                                }
                                            </div>
                                        </div>
                                        }
                                        {(val.energyType==="NG" && val.grd && val.grd.infoRequest && val.dunning.spread.retablissement_client*1!==0 && val.grd.statusGaz!=="Résilié") &&
                                            <div className={"row detail-contract " + (this.state.infoGrd===true ? "detail-contract-selected" : "")}>
                                                <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                    <span className="titre-paiement">Demande en cours auprès de GRD :</span>
                                                    <span className="titre-contract">{val.grd.infoRequest.libellePers} <b className="info">{ val.grd.infoRequest.dateEffet}</b></span>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12 linge-detail">
                                                    <span className="title-bloc">STATUT</span>
                                                    <div className="paiement-status">
                                                        { ((val.dunning.actif > 0 && amountDetteBackup[key]===-1) || amountDetteBackup[key]>0) ?
                                                            <span className="label-status"> {(customer.en ==="msgAll") ? <span><b>Les dettes de tous les contrats doivent être soldées</b></span> :  <span><b>Les dettes du contrat doivent être soldées</b></span>}</span>:
                                                            <span className="label-status label-contract status-termine"><b>Demande d'annulation ou de rétablissement autorisée ✓</b></span>
                                                        }
                                                    </div>

                                                </div>

                                                <div className="col-lg-4 col-md-6 col-sm-12 linge-detail bloc-btn-paiement">
                                                    <span className="title-bloc"><br/></span>
                                                    { ((val.grd.statusGaz==="coupé")) ?
                                                        (
                                                            <div className="tooltipanticipe">
                                                                <button className="btn-dette-v2 label-contract status-termine"><b>Demande d'annulation ou de rétablissement est bien effectuée!</b></button>

                                                            </div>
                                                        ) :
                                                        ((val.dunning.en==="btn" || customer.en==="btn") && val.grd.infoRequest.libelleBoutton) ?
                                                            <button id={"bloc"+val.id}
                                                                    disabled={this.state.retourGrd===false ? false : true}
                                                                    data-request={val.grd.infoRequest.affairId}
                                                                    data-typerequest={val.grd.infoRequest.typeRequest}
                                                                    data-id={val.id} data-contract={key}
                                                                    data-pce={val.grd.infoRequest.pointId}
                                                                    onClick={this.requestGrd} className="btn-dette-v2 aaa">{val.grd.infoRequest.libelleBoutton}</button> :
                                                            <button className="btn-dette-v2 btn-disabled" disabled={true}>
                                                                <span>{val.grd.infoRequest.libelleBoutton}</span>
                                                            </button>

                                                    }
                                                </div>
                                            </div>
                                        }
                                        { (val.id*1===this.state.idDette*1) &&
                                            <div>
                                                <hr className="ligne-grise"/>
                                            </div>
                                        }
                                        {/*debut GRD */}
                                        { (this.state.infoGrd && val.id*1===this.state.idDette*1 && val.grd && val.grd.infoRequest.affairId) &&
                                            <div className="col-12 info-contract-v2 info-enedis" >

                                                <div className="form-group">
                                                    {val.grd.infoRequest.affairId &&
                                                        <div className="col-12">
                                                            <table className="table">
                                                                <thead>
                                                                <tr>
                                                                    <th scope="col">Demande en cours</th>
                                                                    <th scope="col">Date d'effet</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {   <tr>
                                                                    <td>{val.grd.infoRequest.message}</td>
                                                                    <td>{val.grd.infoRequest.dateEffet}</td>
                                                                </tr>
                                                                }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        { (this.state.infoGrd && val.grd && val.grd.openingLevel*1 === 2 ) &&
                                            <div className="col-12 info-contract-v2 info-enedis" >
                                                {(val.grd.infoRequest.nbrjourRestants*1>2 ) &&
                                                    <div className="message-enedis">
                                                        <span>- Annuler la demande de coupure, aucun nouveau frais ne sera facturé.</span>
                                                    </div>
                                                }
                                                {(val.grd.infoRequest.nbrjourRestants*1===2 || (val.grd.infoRequest.nbrjourRestants*1===1 && estAvantLimiteCancelGrdf)) &&
                                                    <div className="message-enedis">
                                                        <span>- Annuler la demande de coupure, frais de {val.dunning.spread.annule_demande_coup_com_j2}€ TCC.<br/></span>
                                                        <span>- Ces frais s’expliquent car la demande de coupure / résiliation est prévue dans moins de 2 jours ouvrés, ils seront facturés sur une facture prochaine.<br/></span>
                                                        <span>- Ce sont des frais GRDF qu'Ohm Energie refacture, plus de détail : </span> <a target="_blank" href="https://www.grdf.fr/documents/10184/5567990/GRDF-Catalogue_2023.pdf/afcc75f4-2565-0f56-35ca-274a028ac8b9?t=1688129128432">Info GRDF</a><br/>
                                                    </div>
                                                }

                                                {((val.grd.infoRequest.nbrjourRestants*1<=1) && !estAvantLimiteCancelGrdf) &&
                                                    <div className="message-enedis">
                                                        <span>- Annuler la demande de coupure, frais de {val.dunning.spread.annule_demande_coup_com_j1}€ TCC.<br/></span>
                                                        <span>- Ces frais s’expliquent car la demande de coupure / résiliation est prévue dans moins de 2 jours ouvrés, ils seront facturés sur une facture prochaine.<br/></span>
                                                        <span>- Ce sont des frais GRDF qu'Ohm Energie refacture, plus de détail : </span> <a target="_blank" href="https://www.grdf.fr/documents/10184/5567990/GRDF-Catalogue_2023.pdf/afcc75f4-2565-0f56-35ca-274a028ac8b9?t=1688129128432">Info GRDF</a><br/>
                                                    </div>
                                                }
                                                {((val.grd.infoRequest.typeRequest==="RET" || val.grd.infoRequest.typeRequest==="CANCEL_RET") && val.grd.statusGaz==="Coupé") &&
                                                    <div className="message-enedis col-12">
                                                        {<>
                                                            <span>Le rétablissement est-il à réaliser dans la journée ? Si Oui, des frais GRDF s’appliqueront.</span>
                                                            <div className="col-12">
                                                                <label><input type="radio" value="oui" checked={this.state.selectedOptionRetab==='oui'} onChange={this.handleOptionChangeRetab}/>
                                                                    <span className="label-enedis-radio">Oui</span>
                                                                </label>
                                                                <label><input type="radio" value="non" checked={this.state.selectedOptionRetab==='non'} onChange={this.handleOptionChangeRetab}/>
                                                                    <span className="label-enedis-radio">Non</span>
                                                                </label>
                                                            </div>
                                                        </>
                                                        }

                                                        <div className="col-lg-5 col-md-12 col-sm-12">
                                                            <label htmlFor="tel">Numéro de téléphone de l'occupant :</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={this.state.tel}
                                                                onChange={this.onChangeTelEnedis}
                                                            />
                                                            {this.state.errorTelEnedis &&
                                                                <div className="alert alert-danger" role="alert">
                                                                    {this.state.errorTelEnedis}
                                                                </div>
                                                            }
                                                        </div>
                                                        {(this.state.selectedOptionRetab==="non" || !estAvantLimiteCancel2Grdf) &&
                                                            <div className="col-lg-5 col-md-12 col-sm-12">
                                                                <label className="form-check-label">
                                                                    Date d’effet souhaitée :
                                                                </label>

                                                                <DatePicker
                                                                    selected={this.state.dateEffet}
                                                                    onChange={handleDateChangeEnedis}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    required
                                                                    className="form-control col-12"
                                                                    placeholderText="dd/mm/yyyy"
                                                                    filterDate={isWeekday}
                                                                    minDate={addDays(new Date(),1)}
                                                                    locale="fr"
                                                                    id={"date_effet"}
                                                                />


                                                            </div>
                                                        }


                                                        { (this.state.selectedOptionRetab==="oui" && estAvantLimiteCancelGrdf) &&
                                                            <div className="message-enedis">
                                                                <span><br/>- Dans la mesure du possible un technicien de GRDF devrait procéder au rétablissement dès aujourd’hui.<br/></span>
                                                                <span>- Des frais de {val.dunning.spread.retab_com_avant_15}€ TCC s’appliqueront<br/></span>
                                                                <span>- Ces frais s’expliquent car la demande de rétablissement est pour aujourd’hui, ils seront facturés sur une facture prochaine.<br/></span>
                                                                <span>- Ce sont des frais GRDF qu'Ohm Energie refacture, plus de détail : </span> <a target="_blank" href="https://www.grdf.fr/documents/10184/5567990/GRDF-Catalogue_2023.pdf/afcc75f4-2565-0f56-35ca-274a028ac8b9?t=1688129128432">Info GRDF</a><br/>
                                                                <span>- Si le rétablissement n’a pas lieu ce jour, aucun frais ne sera imputée.<br/></span>
                                                            </div>
                                                        }

                                                        { (this.state.selectedOptionRetab==="oui" && !estAvantLimiteCancelGrdf && estAvantLimiteCancel2Grdf) &&
                                                            <div className="message-enedis">
                                                                <span><br/>- Dans la mesure du possible un technicien de GRDF devrait procéder au rétablissement dès aujourd’hui.<br/></span>
                                                                <span>- Des frais de {val.dunning.spread.retab_com_apres_15}€ TCC s’appliqueront<br/></span>
                                                                <span>- Ces frais s’expliquent car la demande de rétablissement est pour aujourd’hui, ils seront facturés sur une facture prochaine.<br/></span>
                                                                <span>- Ce sont des frais GRDF qu'Ohm Energie refacture, plus de détail : </span> <a target="_blank" href="https://www.grdf.fr/documents/10184/5567990/GRDF-Catalogue_2023.pdf/afcc75f4-2565-0f56-35ca-274a028ac8b9?t=1688129128432">Info GRDF</a><br/>
                                                                <span>- Si le rétablissement n’a pas lieu ce jour, aucun frais ne sera imputée.<br/></span>
                                                            </div>
                                                        }

                                                        { (this.state.selectedOptionRetab==="oui" && !estAvantLimiteCancelGrdf && !estAvantLimiteCancel2Grdf) &&
                                                            <div className="message-enedis">
                                                                <span><br/>- Il est trop tard pour un rétablissement ce jour, le rétablissement de l’alimentation en gaz est programmé pour demain.<br/></span>
                                                            </div>
                                                        }

                                                        { (this.state.selectedOptionRetab==="non") &&
                                                            <div className="message-enedis">
                                                                <span><br/>- Un technicien de GRDF devrait procéder au rétablissement à la date souhaitée. Il pourra être amené à vous contacter par téléphone.<br/></span>
                                                            </div>
                                                        }

                                                    </div>



                                                }


                                                <>
                                                    {this.state.retourGrd===false &&
                                                        <>
                                                            <button id={"bloc"+val.id}
                                                                    data-request={val.grd.infoRequest.affairId}
                                                                    data-typerequest={val.grd.infoRequest.typeRequest}
                                                                    data-id={val.id} data-contract={key} onClick={this.confirmationActionGrdf}
                                                                    className="btn-dette-v2">{val.grd.infoRequest.libelleBoutton}
                                                            </button>
                                                            {this.state.loading===true &&
                                                                <img className="loading" alt={"loading"}
                                                                     src={loading}/>
                                                            }
                                                        </>
                                                    }

                                                    {this.state.retourGrd!==false &&
                                                        <div className="col-12">
                                                            <br/>
                                                            <span className="msg-customer"><b>{this.state.retourGrd}</b></span>
                                                        </div>
                                                    }
                                                </>


                                            </div>
                                        }

                                        {(this.state.infoGrd && val.grd && val.grd.openingLevel*1!==2) &&
                                            <div className="col-12 info-contract-v2 info-enedis" >
                                                {(val.grd.infoRequest.nbrjourRestants*1>2 ) &&
                                                    <div className="message-enedis">
                                                        <span><br/>- Annuler la demande de coupure, aucun nouveau frais ne sera facturé.</span>
                                                    </div>
                                                }
                                                {(val.grd.infoRequest.nbrjourRestants*1===2 || (val.grd.infoRequest.nbrjourRestants*1===1 && estAvantLimiteCancelGrdf)) &&
                                                    <div className="message-enedis">
                                                        <span><br/>- Annuler la demande de coupure, frais de {val.dunning.spread.annule_demande_coup_non_com_j2}€ TCC.<br/></span>
                                                        <span>- Ces frais s’expliquent car la demande de coupure / résiliation est prévue dans moins de 2 jours ouvrés, ils seront facturés sur une facture prochaine.<br/></span>
                                                        <span>- Ce sont des frais GRDF qu'Ohm Energie refacture, plus de détail : </span> <a target="_blank" href="https://www.grdf.fr/documents/10184/5567990/GRDF-Catalogue_2023.pdf/afcc75f4-2565-0f56-35ca-274a028ac8b9?t=1688129128432">Info GRDF</a><br/>
                                                    </div>
                                                }

                                                {((val.grd.infoRequest.nbrjourRestants*1<=1) && !estAvantLimiteCancelGrdf) &&
                                                    <div className="message-enedis">
                                                        <span><br/>- Annuler la demande de coupure, frais de {val.dunning.spread.annule_demande_coup_non_com_j1}€ TCC.<br/></span>
                                                        <span>- Ces frais s’expliquent car la demande de coupure / résiliation est prévue dans moins de 2 jours ouvrés, ils seront facturés sur une facture prochaine.<br/></span>
                                                        <span>- Ce sont des frais GRDF qu'Ohm Energie refacture, plus de détail : </span> <a target="_blank" href="https://www.grdf.fr/documents/10184/5567990/GRDF-Catalogue_2023.pdf/afcc75f4-2565-0f56-35ca-274a028ac8b9?t=1688129128432">Info GRDF</a><br/>
                                                    </div>
                                                }


                                                {((val.grd.infoRequest.typeRequest==="RET" || val.grd.infoRequest.typeRequest==="CANCEL_RET") && val.grd.statusGaz==="Coupé") &&
                                                    <div className="message-enedis col-12">
                                                        {<>
                                                            <span>Le rétablissement est-il à réaliser dans la journée ? Si Oui, des frais GRDF s’appliqueront.</span>
                                                            <div className="col-12">
                                                                <label><input type="radio" value="oui" checked={this.state.selectedOptionRetab==='oui'} onChange={this.handleOptionChangeRetab}/>
                                                                    <span className="label-enedis-radio">Oui</span>
                                                                </label>
                                                                <label><input type="radio" value="non" checked={this.state.selectedOptionRetab==='non'} onChange={this.handleOptionChangeRetab}/>
                                                                    <span className="label-enedis-radio">Non</span>
                                                                </label>
                                                            </div>
                                                        </>
                                                        }

                                                        <div className="col-lg-5 col-md-12 col-sm-12">
                                                            <label htmlFor="tel">Numéro de téléphone de l'occupant :</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={this.state.tel}
                                                                onChange={this.onChangeTelEnedis}
                                                            />
                                                            {this.state.errorTelEnedis &&
                                                                <div className="alert alert-danger" role="alert">
                                                                    {this.state.errorTelEnedis}
                                                                </div>
                                                            }
                                                        </div>
                                                        {(this.state.selectedOptionRetab==="non" || !estAvantLimiteCancelGrdf) &&
                                                            <div className="col-lg-5 col-md-12 col-sm-12">
                                                                <label className="form-check-label">
                                                                    Date d’effet souhaitée :
                                                                </label>

                                                                <DatePicker
                                                                    selected={this.state.dateEffet}
                                                                    onChange={handleDateChangeEnedis}
                                                                    dateFormat="dd/MM/yyyy"
                                                                    required
                                                                    className="form-control col-12"
                                                                    placeholderText="dd/mm/yyyy"
                                                                    filterDate={isWeekday}
                                                                    minDate={addDays(new Date(),1)}
                                                                    locale="fr"
                                                                    id={"date_effet"}
                                                                />


                                                            </div>
                                                        }


                                                        { (this.state.selectedOptionRetab==="oui" && estAvantLimiteCancelGrdf) &&
                                                            <div className="message-enedis">
                                                                <span><br/>- Dans la mesure du possible un technicien de GRDF devrait procéder au rétablissement dès aujourd’hui.<br/></span>
                                                                <span>- Des frais de {val.dunning.spread.retab_non_com_avant_15}€ TCC s’appliqueront<br/></span>
                                                                <span>- Ces frais s’expliquent car la demande de rétablissement est pour aujourd’hui et que votre compteur est non communicant, ils seront facturés sur une facture prochaine.<br/></span>
                                                                <span>- Ce sont des frais GRDF qu'Ohm Energie refacture, plus de détail : </span> <a target="_blank" href="https://www.grdf.fr/documents/10184/5567990/GRDF-Catalogue_2023.pdf/afcc75f4-2565-0f56-35ca-274a028ac8b9?t=1688129128432">Info GRDF</a><br/>
                                                            </div>
                                                        }

                                                        { ((this.state.selectedOptionRetab==="oui" && !estAvantLimiteCancelGrdf) || this.state.selectedOptionRetab==="non") &&
                                                            <div className="message-enedis">
                                                                <span><br/>- Il est trop tard pour un rétablissement ce jour, le rétablissement de l’alimentation en gaz est programmé pour demain.<br/></span>
                                                                <span>- Des frais de {val.dunning.spread.retab_non_com_apres_15}€ TCC s’appliqueront<br/></span>
                                                                <span>- Ces frais s’expliquent car votre compteur est non communicant, ils seront facturés sur une facture prochaine.<br/></span>
                                                                <span>- Ce sont des frais GRDF qu'Ohm Energie refacture, plus de détail : </span> <a target="_blank" href="https://www.grdf.fr/documents/10184/5567990/GRDF-Catalogue_2023.pdf/afcc75f4-2565-0f56-35ca-274a028ac8b9?t=1688129128432">Info GRDF</a><br/>
                                                            </div>
                                                        }


                                                    </div>



                                                }



                                                {this.state.retourGrd===false &&
                                                    <>
                                                        <button id={"bloc"+val.id}
                                                                data-request={val.grd.infoRequest.affaireId}
                                                                data-typerequest={val.grd.infoRequest.typeRequest}
                                                                data-id={val.id} data-contract={key} onClick={this.confirmationActionGrdf}
                                                                className="btn-dette-v2 col-3 btn-enedis">
                                                            {val.grd.infoRequest.libelleBoutton}
                                                        </button>
                                                        {this.state.loading===true &&
                                                            <img className="loading" alt={"loading"}
                                                                 src={loading}/>
                                                        }
                                                    </>
                                                }

                                                {this.state.retourGrd!==false &&
                                                    <div className="col-12">
                                                        <br/>
                                                        <span className="msg-customer"><b>{this.state.retourGrd}</b></span>
                                                    </div>
                                                }

                                            </div>
                                        }
                                        {/*debut Enedis */}
                                        { (this.state.infoEnedis && val.id*1===this.state.idDette*1) &&
                                            <div className="col-12 info-contract-v2 info-enedis" >
                                                {val.enedis.body.onGoingInterventions.situationAlimentation==="Alimenté" &&
                                                    <>
                                                        <div className="form-group">
                                                            {val.enedis.body.onGoingInterventions.nbrDemande>0 &&
                                                                <div className="col-12">
                                                                    <table className="table">
                                                                        <thead>
                                                                        <tr>
                                                                            <th scope="col">Demande en cours</th>
                                                                            <th scope="col">Date d'effet</th>
                                                                        </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        {   val.enedis.body.onGoingInterventions.listeEncours &&
                                                                            val.enedis.body.onGoingInterventions.listeEncours.map((demande, index) =>
                                                                                <tr  key={index}>
                                                                                    <td>{demande.message}</td>
                                                                                    <td>{demande.date}</td>
                                                                                </tr>
                                                                            )

                                                                        }
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            }
                                                            {(val.enedis.body.onGoingInterventions.openingLevel*1===2) &&
                                                                <>
                                                                    {(val.enedis.body.onGoingInterventions.nbrjourRestants*1<1 || (val.enedis.body.onGoingInterventions.nbrjourRestants*1===1 && !estAvantLimiteCancel))&&
                                                                        <div className="message-enedis">
                                                                            <span>- Il est trop tard pour faire annuler la demande, procédez à un rétablissement et/ou contactez notre service client.</span>
                                                                        </div>
                                                                    }
                                                                    {(val.enedis.body.onGoingInterventions.nbrjourRestants*1>1 || (val.enedis.body.onGoingInterventions.nbrjourRestants*1===1 && estAvantLimiteCancel)
                                                                        ) &&
                                                                        <>
                                                                            {this.state.retourEnedis===false &&
                                                                                <>
                                                                                    <button id={"bloc"+val.id}
                                                                                            data-request={val.enedis.body.onGoingInterventions.affaireId}
                                                                                            data-typerequest={val.enedis.body.onGoingInterventions.typeRequest}
                                                                                            data-id={val.id} data-contract={key} onClick={this.confirmationAction}
                                                                                            className="btn-dette-v2">{val.enedis.body.onGoingInterventions.libelleBoutton}
                                                                                    </button>
                                                                                    {this.state.loading===true &&
                                                                                        <img className="loading" alt={"loading"}
                                                                                             src={loading}/>
                                                                                    }
                                                                                </>
                                                                            }

                                                                            {this.state.retourEnedis!==false &&
                                                                                <div className="col-12">
                                                                                    <br/>
                                                                                    <span className="msg-customer"><b>{this.state.retourEnedis}</b></span>
                                                                                </div>
                                                                            }
                                                                        </>

                                                                    }
                                                                </>
                                                            }

                                                            {(val.enedis.body.onGoingInterventions.openingLevel*1!==2) &&
                                                                <>
                                                                    {((val.enedis.body.onGoingInterventions.nbrjourRestants*1<2 || (val.enedis.body.onGoingInterventions.nbrjourRestants===2 && !estAvantLimiteCancel)))&&
                                                                        <div className="message-enedis">
                                                                            <span>- Il est trop tard pour faire annuler la demande de manière automatique, contactez notre service client qui contactera la Ligne Affaires Urgentes d’Enedis.</span>
                                                                        </div>
                                                                    }
                                                                    {(
                                                                            (
                                                                                val.enedis.body.onGoingInterventions.nbrjourRestants*1>2 || (val.enedis.body.onGoingInterventions.nbrjourRestants===2 && estAvantLimiteCancel)
                                                                            )) &&
                                                                        <>
                                                                            {this.state.retourEnedis===false &&
                                                                                <>
                                                                                    <button id={"bloc"+val.id}
                                                                                            data-request={val.enedis.body.onGoingInterventions.affaireId}
                                                                                            data-typerequest={val.enedis.body.onGoingInterventions.typeRequest}
                                                                                            data-id={val.id} data-contract={key} onClick={this.confirmationAction}
                                                                                            className="btn-dette-v2 col-3 btn-enedis">
                                                                                        {val.enedis.body.onGoingInterventions.libelleBoutton}
                                                                                    </button>
                                                                                    {this.state.loading===true &&
                                                                                        <img className="loading" alt={"loading"}
                                                                                             src={loading}/>
                                                                                    }
                                                                                </>
                                                                            }

                                                                            {this.state.retourEnedis!==false &&
                                                                                <div className="col-12">
                                                                                    <br/>
                                                                                    <span className="msg-customer"><b>{this.state.retourEnedis}</b></span>
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                    </>

                                                }
                                                {(val.enedis.body.onGoingInterventions.situationAlimentation==="Coupé" || val.enedis.body.onGoingInterventions.situationAlimentation==="Limité")&&
                                                    <div>

                                                        <div className="message-enedis">
                                                            <span>- Le rétablissement est gratuit, aucun nouveau frais ne sera facturé.</span>
                                                        </div>
                                                        {val.enedis.body.onGoingInterventions.openingLevel*1===2 &&
                                                            <div className="message-enedis">
                                                <span>
                                                    - Le rétablissement devrait avoir lieu quasi-instantanément.<br />
                                                    - Dans le cas d’une mauvaise communication avec le compteur, il aura lieu le lendemain. <br />
                                                    - Si ça n’est toujours pas le cas contactez notre service client. <br /> <br />
                                                </span>
                                                            </div>
                                                        }

                                                        {val.enedis.body.onGoingInterventions.nbrDemande>0 &&
                                                            <div className="col-12">
                                                                <table className="table">
                                                                    <thead>
                                                                    <tr>
                                                                        <th scope="col">Demande en cours</th>
                                                                        <th scope="col">Date d'effet</th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {   val.enedis.body.onGoingInterventions.listeEncours &&
                                                                        val.enedis.body.onGoingInterventions.listeEncours.map((demande, index) =>
                                                                            <tr  key={index}>
                                                                                <td>{demande.message}</td>
                                                                                <td>{demande.date}</td>
                                                                            </tr>
                                                                        )

                                                                    }
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                        }

                                                        {val.enedis.body.onGoingInterventions.openingLevel*1!==2 &&
                                                            <div className="message-enedis col-12">
                                                                { estAvantLimite && <>
                                                                    <span>Le rétablissement est-il à réaliser dans la journée ?</span>
                                                                    <div className="col-12">
                                                                        <label><input type="radio" value="oui" checked={this.state.selectedOptionRetab==='oui'} onChange={this.handleOptionChangeRetab}/>
                                                                            <span className="label-enedis-radio">Oui</span>
                                                                        </label>
                                                                        <label><input type="radio" value="non" checked={this.state.selectedOptionRetab==='non'} onChange={this.handleOptionChangeRetab}/>
                                                                            <span className="label-enedis-radio">Non</span>
                                                                        </label>
                                                                    </div>
                                                                </>
                                                                }
                                                                { (this.state.selectedOptionRetab==="oui" && estAvantLimite) &&
                                                                    <div className="message-enedis">
                                                                        <span>Dans la mesure du possible un technicien d’ENEDIS devrait procéder au rétablissement dès aujourd’hui.</span>
                                                                    </div>
                                                                }
                                                                { (this.state.selectedOptionRetab==="non" || !estAvantLimite) &&
                                                                    <div className="message-enedis">
                                                                        <span>Un technicien d’ENEDIS devrait procéder au rétablissement à la date souhaitée. <br />Il pourra être amené à vous contactez par téléphone.</span>
                                                                    </div>
                                                                }

                                                                <div className="col-lg-5 col-md-12 col-sm-12">
                                                                    <label htmlFor="tel">Numéro de téléphone de l'occupant :</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={this.state.tel}
                                                                        onChange={this.onChangeTelEnedis}
                                                                    />
                                                                    {this.state.errorTelEnedis &&
                                                                        <div className="alert alert-danger" role="alert">
                                                                            {this.state.errorTelEnedis}
                                                                        </div>
                                                                    }
                                                                </div>
                                                                {(this.state.selectedOptionRetab==="non" || !estAvantLimite) &&
                                                                    <div className="col-lg-5 col-md-12 col-sm-12">
                                                                        <label className="form-check-label">
                                                                            Date d’effet souhaitée
                                                                        </label>

                                                                        <DatePicker
                                                                            selected={this.state.dateEffet}
                                                                            onChange={handleDateChangeEnedis}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            required
                                                                            className="form-control col-12"
                                                                            placeholderText="dd/mm/yyyy"
                                                                            filterDate={isWeekday}
                                                                            minDate={addDays(new Date(),1)}
                                                                            locale="fr"
                                                                            id={"date_effet"}
                                                                        />


                                                                    </div>
                                                                }

                                                            </div>

                                                        }

                                                        <div className="form-group">
                                                            {(this.state.retourEnedis===false && !this.state.errorTelEnedis) &&
                                                                <>
                                                                    <button id={"bloc"+val.id}
                                                                            data-request={val.enedis.body.onGoingInterventions.affaireId}
                                                                            data-typerequest={val.enedis.body.onGoingInterventions.typeRequest}
                                                                            data-id={val.id} data-contract={key} onClick={this.confirmationAction}
                                                                            className="btn-dette-v2 col-3 btn-enedis">{val.enedis.body.onGoingInterventions.libelleBoutton}</button>
                                                                    {this.state.loading===true &&
                                                                        <img className="loading" alt={"loading"}
                                                                             src={loading}/>
                                                                    }
                                                                </>
                                                            }
                                                            {this.state.retourEnedis!==false &&
                                                                <div className="col-12" >
                                                                    <br/>
                                                                    <span className="msg-customer"><b>{this.state.retourEnedis}</b></span>
                                                                </div>
                                                            }
                                                        </div>


                                                    </div>
                                                }

                                            </div>

                                        }
                                        {/*Fin Enedis */}

                                        { (val.id*1===this.state.idDette*1 && !this.state.infoEnedis && !this.state.infoGrd) &&

                                            <div id={val.id} className="col-12 info-dette info-dette-active" >
                                                <div className="col-12 titre-info-paiement">
                                                    <span className="titre-paiement">{this.state.paymentType==="dettes" ? "Liste des éléments en dettes actives" : "Liste des factures à venir"}</span>
                                                </div>

                                                <div className="info-contract-v2">
                                                    <div className="info-table">
                                                        {
                                                            ( this.state.paymentType!=="dettes")&&
                                                            <div>
                                                                {
                                                                    this.state.loadingAnticip===true &&
                                                                    <img className="loading" alt={"loading"} src={loading}/>
                                                                }

                                                            </div>
                                                        }
                                                        <table className="table">
                                                            { this.state.paymentType==="dettes" &&
                                                                <thead>
                                                                <tr>
                                                                    <th className="title-bloc" scope="col">Type</th>
                                                                    <th className="title-bloc" scope="col">Nom</th>
                                                                    <th className="title-bloc" scope="col">Date</th>
                                                                    <th className="title-bloc" scope="col">Montant</th>
                                                                </tr>
                                                                </thead>
                                                            }

                                                            { this.state.paymentType!=="dettes" &&
                                                                <thead>
                                                                <tr>
                                                                    <th className="title-bloc" scope="col">Numéro de facture</th>
                                                                    <th className="title-bloc" scope="col">Date de facture</th>
                                                                    <th className="title-bloc" scope="col">Date d'échéance</th>
                                                                    <th className="title-bloc" scope="col">Montant</th>
                                                                    <th className="title-bloc" scope="col"></th>
                                                                </tr>
                                                                </thead>
                                                            }
                                                            <tbody>
                                                            {   val.dunning.payment_list &&
                                                                val.dunning.payment_list.map((payment, index) =>
                                                                    <tr  key={index}>
                                                                        <td>Paiement</td>
                                                                        <td>{payment.display_name}</td>
                                                                        <td>{payment.date}</td>
                                                                        <td>{payment.residual_amount_debt} &euro;</td>
                                                                    </tr>
                                                                )

                                                            }

                                                            {
                                                                val.dunning.invoice_list && this.state.paymentType==="dettes" &&
                                                                val.dunning.invoice_list.map((invoice, index) =>
                                                                    <tr  key={index}>
                                                                        <td>Facture</td>
                                                                        <td>{invoice.invoice_number}</td>
                                                                        <td>{invoice.invoice_date}</td>
                                                                        <td>{invoice.residual_amount_debt} &euro;</td>
                                                                    </tr>
                                                                )

                                                            }
                                                            {

                                                                val.dunning.invoice_list && this.state.paymentType!=="dettes"&&
                                                                val.dunning.invoice_list.map((invoice, index) =>
                                                                    <tr  key={index}>
                                                                        <td>{invoice.invoice_number}</td>
                                                                        <td>{invoice.invoice_date}</td>
                                                                        <td>{invoice.invoice_date_due}</td>
                                                                        <td>{invoice.residual_amount_debt} &euro;</td>
                                                                        <td><input
                                                                            value={invoice.invoice_number}
                                                                            data-amount={invoice.residual_amount_debt}
                                                                            data-dettes={amountDetteBackup[key] > -1 ? amountDetteBackup[key] : val.dunning.actif}
                                                                            data-contract = {key}
                                                                            type="checkbox"
                                                                            checked={this.state.listRefInvoiceAnticip.includes(invoice.invoice_number) ? true : false}
                                                                            onChange={this.handleSelectInvoice}
                                                                        /></td>
                                                                    </tr>
                                                                )

                                                            }
                                                            </tbody>
                                                        </table>
                                                        <div className="dette-active">
                                                            <span>{this.state.paymentType==="dettes" ? "Montant total : " : "Total sélectionné : "}</span><span className="import-val"> {val.dunning.actif} &euro;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="info-contract row ">
                                                    <div className="method-payment col-lg-8 col-md-12 col-sm-12">
                                                        <div className="select-paiement">
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Comment souhaitez-vous régler {this.state.paymentType==="dettes" ? "vos dettes en cours" : "vos factures" } ?
                                                 </span>
                                                        </div>
                                                        <div className="form-check">
                                                            <div className="row option-payment">
                                                                <div className={"col-12 option-payment-1 option-payment-info "}
                                                                     data-val="pic"
                                                                     data-methodpayment="piccb"
                                                                     data-partialamount={val.dunning.actif}
                                                                     data-amountmaxupdate={val.dunning.actif}
                                                                     onClick={this.handleOptionChangeTypePayment}
                                                                >

                                                                    <div className="col-12 div-type-etal"
                                                                         data-methodpayment="piccb"
                                                                         data-val="pic"
                                                                         data-partialamount={val.dunning.actif}
                                                                         data-amountmaxupdate={val.dunning.actif}
                                                                         onClick={this.handleOptionChangeTypePayment}>

                                                                        <div className={"etat-type-etal " + (this.state.typePayment === "pic" ? "etape-selected" : "")}
                                                                             data-methodpayment="piccb"
                                                                             data-val="pic"
                                                                             data-partialamount={val.dunning.actif}
                                                                             data-amountmaxupdate={val.dunning.actif}
                                                                             onClick={this.handleOptionChangeTypePayment}>
                                                                        </div>
                                                                        <div className="label-type-etal"
                                                                             data-methodpayment="piccb"
                                                                             data-val="pic"
                                                                             data-partialamount={val.dunning.actif}
                                                                             data-amountmaxupdate={val.dunning.actif}
                                                                             onClick={this.handleOptionChangeTypePayment}>
                                                        <span
                                                            data-val="pic"
                                                            data-partialamount={val.dunning.actif}
                                                            data-amountmaxupdate={val.dunning.actif}
                                                            onClick={this.handleOptionChangeTypePayment}
                                                        >
                                                            Je préfère opter pour un</span>
                                                                        <span className="option-payment-span"
                                                                              data-val="pic"
                                                                              data-methodpayment="piccb"
                                                                              data-partialamount={val.dunning.actif}
                                                                              data-amountmaxupdate={val.dunning.actif}
                                                                              onClick={this.handleOptionChangeTypePayment}
                                                                        > {val.status ==="Actif" ? "paiement instantané complet" : "paiement instantané"}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                { val.dunning.spread.afficheEtalement===true &&
                                                                    <div className={"col-12 option-payment-2 option-payment-info "}
                                                                         data-partialamount={val.dunning.partialAmount}
                                                                         data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                                         data-val="pipe"
                                                                         data-methodpayment="pipcb"
                                                                         onClick={this.handleOptionChangeTypePayment}
                                                                    >

                                                                        <div data-partialamount={val.dunning.partialAmount}
                                                                             data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                                             data-val="pipe"
                                                                             data-methodpayment="pipcb"
                                                                             onClick={this.handleOptionChangeTypePayment}
                                                                             className="col-12">

                                                                            <div className={"etat-type-etal " + (this.state.typePayment === "pipe" ? "etape-selected" : "")}
                                                                                 data-partialamount={val.dunning.partialAmount}
                                                                                 data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                                                 data-val="pipe"
                                                                                 data-methodpayment="pipcb"
                                                                                 onClick={this.handleOptionChangeTypePayment}>
                                                                            </div>
                                                                            <div className="label-type-etal"
                                                                                 data-partialamount={val.dunning.partialAmount}
                                                                                 data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                                                 data-val="pipe"
                                                                                 data-methodpayment="pipcb"
                                                                                 onClick={this.handleOptionChangeTypePayment}>
                                                        <span
                                                            data-partialamount={val.dunning.partialAmount}
                                                            data-val="pipe"
                                                            data-methodpayment="pipcb"
                                                            data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                            onClick={this.handleOptionChangeTypePayment}
                                                        >Je préfère opter pour un</span>
                                                                            <span className="option-payment-span"
                                                                                  data-partialamount={val.dunning.partialAmount}
                                                                                  data-val="pipe"
                                                                                  data-methodpayment="pipcb"
                                                                                  data-nbretal={this.state.paymentType === "dettes" ? val.dunning.spread.nb_max : val.dunning.spread.nb_max_anticipe}
                                                                                  onClick={this.handleOptionChangeTypePayment}
                                                                            > paiement partiel immédiat et planifier l'étalement</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }

                                                            </div>
                                                        </div>
                                                        { this.state.typePayment==="pic" &&
                                                            <>
                                                                {val.status !=="Actif" &&
                                                                    <>
                                                <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Paramètres du paiement instantané
                                                </span>
                                                                        <div className={"row option-payment info-amount-update col-12 option-payment-1 option-payment-info valid-option"}>
                                                                            <div className="row div-input-amount">
                                                                                <label className="montant-partiel" htmlFor="montant">Montant : </label>
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control input-amount "
                                                                                    name="montant"
                                                                                    data-amounttotal={val.dunning.actif}
                                                                                    data-amountmin={val.dunning.spread.ct_ter_mt_min}
                                                                                    defaultValue={val.dunning.actif}
                                                                                    onChange={this.onChangeAmountUpdate}
                                                                                />
                                                                                <span className="devis-input-amount"> &euro;</span>
                                                                            </div>
                                                                        </div>
                                                                        {this.state.errorMsgUpdateAmount &&
                                                                            <div className="alert alert-danger" role="alert">
                                                                                {this.state.errorMsgUpdateAmount}
                                                                            </div>
                                                                        }
                                                                        {this.state.valideMsgUpdateAmount &&
                                                                            <div className="alert alert-success" role="alert">
                                                                                {this.state.valideMsgUpdateAmount}
                                                                            </div>
                                                                        }
                                                                    </>
                                                                }
                                                                { (this.state.errorMsgUpdateAmount==="")&&
                                                                    <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Mode de paiement
                                                </span>
                                                                }

                                                            </>
                                                        }
                                                        { (val.dunning.partialAmount>0 && this.state.typePayment==="pipe")&&
                                                            <span>
                                                    <img src={etape} alt="valide" className="etape-option-payment"/>
                                                    Paramètres du paiement partiel :
                                                </span>
                                                        }
                                                        { (val.dunning.partialAmount>0)&&
                                                            (this.state.typePayment==="pipe") &&
                                                            <div className="form-check">
                                                                <div className="row col-12" id="pip">

                                                                    <div className="col-lg-5 col-md-12 col-sm-12 div-etal">
                                                                        <label className="titre-paiement">Montant du paiement partiel :</label>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-12 col-sm-12 div-etal">
                                                                        <select className="form-control info-montant-partiel" id="amountEtalSelect" onChange={this.handleOptionChangeInfoEtalement}>
                                                                            {   val.dunning.spread_force &&
                                                                                val.dunning.spread_force.map((elt, index) =>
                                                                                    <option  data-nbrmax={elt.nb_max}
                                                                                             value={elt.amount}
                                                                                             selected={elt.amount===val.dunning.partialAmount ? true : ""}  key={index}>{elt.amount} &euro;</option>
                                                                                )

                                                                            }
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-lg-4 col-md-12 col-sm-12  div-etal-select">
                                                                        <label className="amount-select">{this.state.partialAmount}&euro;</label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        }
                                                        { ((this.state.typePayment === "pic" || this.state.typePayment==="pipe") && (this.state.errorMsgUpdateAmount==="")) &&
                                                            <div className={"form-check "}>
                                                                <div className={"option-payment row"}>
                                                                    <div  className={"col-12 option-payment-1 option-payment-info "}
                                                                          data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                          onClick={this.handleOptionChangeMethodPayment}>

                                                                        <div className="col-12 moyen-payment"
                                                                             data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                             onClick={this.handleOptionChangeMethodPayment}>
                                                                            <div className="col-6 libelle-moyen-payment"
                                                                                data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                                onClick={this.handleOptionChangeMethodPayment}
                                                                            ><div className={"etat-type-etal " + ((this.state.methodPayment === "piccb" || this.state.methodPayment === "pipcb") ? "etape-selected" : "")}
                                                                                  data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                                  onClick={this.handleOptionChangeMethodPayment}>
                                                                            </div>
                                                                                <div className="label-type-etal"
                                                                                     data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                                     onClick={this.handleOptionChangeMethodPayment}>
                                                                    <span
                                                                        data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                        onClick={this.handleOptionChangeMethodPayment}
                                                                    >Paiement par </span>
                                                                                <span className="option-payment-span"
                                                                                      data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                                      onClick={this.handleOptionChangeMethodPayment}
                                                                                >Carte bancaire</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="moyen-payment-cb col-6"
                                                                                 data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                                 onClick={this.handleOptionChangeMethodPayment}>
                                                                                <img className="logocb" alt={"CB"} src={cb2}
                                                                                     data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                                     onClick={this.handleOptionChangeMethodPayment}
                                                                                />
                                                                                <img className="logocb" alt={"Master"} src={master}
                                                                                     data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                                     onClick={this.handleOptionChangeMethodPayment}
                                                                                />
                                                                                <img className="logocb" alt={"Visa"} src={visa}
                                                                                     data-methodpayment={this.state.typePayment === "pic" ? "piccb" : "pipcb"}
                                                                                     onClick={this.handleOptionChangeMethodPayment}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {(val.dunning.spread.prelemvementAuto===true || (val.dunning.spread.prelemvementAutoAnticipe && this.state.paymentType==='anticipe') || this.state.typePayment === "pic") &&
                                                                        <div className={"col-12 tooltippis option-payment-2 payment-slimpay option-payment-info "}
                                                                             data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                             onClick={this.handleOptionChangeMethodPayment}
                                                                        >

                                                                            <div className="col-12 moyen-payment"
                                                                                 data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                 onClick={this.handleOptionChangeMethodPayment}
                                                                            >

                                                                                    <div className={"etat-type-etal " + ((this.state.methodPayment === "picvir" || this.state.methodPayment === "pipvir") ? "etape-selected" : "")}
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}>
                                                                                    </div>
                                                                                    <div className="label-type-etal"
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}>
                                                                                        <div
                                                                                            className="col-12 libelle-moyen-payment payment-slimpay2"
                                                                                            data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                            onClick={this.handleOptionChangeMethodPayment}>
                                                                            <span
                                                                                data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                onClick={this.handleOptionChangeMethodPayment}
                                                                            >Payer avec ma banque

                                                                            </span>
                                                                                    <span className="option-payment-span"
                                                                                          data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                          onClick={this.handleOptionChangeMethodPayment}> Simple, rapide et sécurisé
                                                                            </span>
                                                                                        </div>

                                                                                </div>

                                                                                <div className="moyen-payment-cb col-6"
                                                                                     data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                     onClick={this.handleOptionChangeMethodPayment}>
                                                                                    <img className="logobank" alt={"Payer avec ma banque"} src={bnp}
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                                    />
                                                                                    <img className="logobank" alt={"Payer avec ma banque"} src={ca}
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                                    />
                                                                                    <img className="logobank" alt={"Payer avec ma banque"} src={bours}
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                                    />
                                                                                    <img className="logobank" alt={"Payer avec ma banque"} src={banquerouge}
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                                    />
                                                                                    <img className="logobank" alt={"Payer avec ma banque"} src={x}
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                                    />
                                                                                    <img className="logobank" alt={"Payer avec ma banque"} src={sg}
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                                    />
                                                                                    <img className="logobank" alt={"Payer avec ma banque"} src={autres}
                                                                                         data-methodpayment={this.state.typePayment === "pic" ? "picvir" : "pipvir"}
                                                                                         onClick={this.handleOptionChangeMethodPayment}
                                                                                    />
                                                                                </div>

                                                                            </div>
                                                                            <span className="tooltiptext">{"Payez directement depuis votre application bancaire avec notre partenaire Tink."}</span>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }

                                                        { (val.dunning.partialAmount>0 && this.state.typePayment==="pipe" && (this.state.methodPayment==="pipcb" || this.state.methodPayment==="pipvir") )&&
                                                            <>
                                                    <span>
                                                        <img src={etape} alt="valide" className="etape-option-payment"/>
                                                        Paramètres de l'étalement
                                                    </span>
                                                                <div className="form-check">
                                                                    <div className="row">
                                                                        { val.dunning.spread.prelemvementAuto===true &&
                                                                            <div onClick={this.handleOptionChangeMethodEtalement} data-val="sdd" className={"option-payment-1 payment-slimpay col-lg-12 col-md-12 col-sm-12 option-payment-info "}>
                                                                                <div className="col-12 moyen-payment" onClick={this.handleOptionChangeMethodEtalement}  data-val="sdd">
                                                                                    <div className={"etat-type-etal " +(this.state.methodPaymentEtalement==="sdd" ? "etape-selected" : "")}
                                                                                         data-val="sdd"
                                                                                         onClick={this.handleOptionChangeMethodEtalement}>
                                                                                    </div>
                                                                                    <div className="label-type-etal"
                                                                                         data-val="sdd"
                                                                                         onClick={this.handleOptionChangeMethodEtalement}>
                                                                                    <span data-val="sdd">Prélèvement automatique</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {(this.state.methodPayment!=="picvir" && this.state.methodPayment!=="pipvir" )&&
                                                                            <div data-val="cb"
                                                                                 onClick={this.handleOptionChangeMethodEtalement}
                                                                                 className={"col-12 option-payment-2 option-payment-info "}>

                                                                                <div onClick={this.handleOptionChangeMethodEtalement}  data-val="cb"
                                                                                     className="col-12 moyen-payment ">
                                                                                    <div onClick={this.handleOptionChangeMethodEtalement} className="col-6 libelle-moyen-payment" data-val="cb">
                                                                                        <div className={"etat-type-etal " +(this.state.methodPaymentEtalement==="cb" ? "etape-selected" : "")}
                                                                                             data-val="cb"
                                                                                             onClick={this.handleOptionChangeMethodEtalement}>
                                                                                        </div>
                                                                                        <div className="label-type-etal"
                                                                                             data-val="cb"
                                                                                             onClick={this.handleOptionChangeMethodEtalement}>
                                                                                        <span data-val="cb">Paiement par </span>
                                                                                        <span data-val="cb" className="option-payment-span">Carte bancaire</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div onClick={this.handleOptionChangeMethodEtalement} data-val="cb" className="moyen-payment-cb col-6">
                                                                                        <img data-val="cb" className="logocb" alt={"CB"} src={cb2}/>
                                                                                        <img data-val="cb" className="logocb" alt={"Master"} src={master}/>
                                                                                        <img data-val="cb" className="logocb" alt={"Visa"} src={visa}/>
                                                                                    </div>

                                                                                </div>
                                                                            </div>

                                                                        }
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                        { (val.dunning.partialAmount>0 && this.state.methodPaymentEtalement!=="")&&
                                                            <div className="form-check div-info-etal">
                                                                { (this.state.typePayment==="pipe") &&
                                                                    <div className="form-check" id="pip">
                                                                        <div className="row col-12">
                                                                            <div className="col-lg-5 col-md-12 col-sm-12 div-date-etal">
                                                                                <label className="form-check-label titre-paiement">
                                                                                    Date du premier prélèvement
                                                                                </label>

                                                                                <DatePicker
                                                                                    selected={this.state.startDate}
                                                                                    onChange={handleDateChange}
                                                                                    dateFormat="dd/MM/yyyy"
                                                                                    required
                                                                                    className="form-control col-12 date-select"
                                                                                    placeholderText="dd/mm/yyyy"
                                                                                    filterDate={isWeekday}
                                                                                    minDate={addDays(new Date(), 1)}
                                                                                    maxDate={addDays(new Date(), this.state.paymentType === "dettes" ? val.dunning.spread.nbrDayMax : val.dunning.spread.nbrDayMaxAnticipe)}
                                                                                    locale="fr"
                                                                                />
                                                                            </div>
                                                                            <div className="col-lg-4 col-md-12 col-sm-12 div-date-etal">
                                                                                <label className="form-check-label titre-paiement">
                                                                                    Nombre d’étalements
                                                                                </label>
                                                                                <select
                                                                                    onChange={this.handleOptionChangeNbrEtalement}
                                                                                    className="form-control col-12 etal-select nbrEtal">
                                                                                    {
                                                                                        this.afficheNbreEtal(nbrEtal,this.state.nbrEtalement*1)
                                                                                    }
                                                                                </select>
                                                                            </div>


                                                                            <div className="col-lg-3 col-md-12 col-sm-12 info-calcul-etal">
                                                                                <button className=" btn btn-calcul">
                                                                                    <span className="form-check-label nb-et-select">{this.state.nbrEtalement} X </span>
                                                                                    <span className="form-check-label et-select">{ ((val.dunning.actif - this.state.partialAmount)/this.state.nbrEtalement*1).toFixed(2) }&euro;</span>
                                                                                </button>

                                                                                { val.dunning.payment_list && val.dunning.payment_list.length>0 &&
                                                                                    <>
                                                                                        <img className="help" alt={"Aide"} src={help}  />
                                                                                        <span className="tooltiphelp">{"Il s’agit du montant mensuel théorique, il est possible que le montant réel diffère.\n" +
                                                                                        "Vous trouverez le détail dans le tableau récapitulatif à droite."}</span>
                                                                                    </>
                                                                                }

                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }

                                                    </div>


                                                { infoEtalementTab && this.state.infoEtalement && this.state.methodPaymentEtalement!=="" &&
                                                    <div className="info-table-etalement col-lg-4 col-md-12 col-sm-12">
                                                        <div className="info-li-etalement">
                                                        <ul>
                                                        {   infoEtalementTab &&
                                                            infoEtalementTab.map((payment, index) =>
                                                                (payment.name==='total')?
                                                                    <li className ={payment.datepayment === format(new Date(),"dd/MM/yyyy") ? "li-total" : "li-detail"} key={index}>
                                                                        {payment.datepayment === format(new Date(),"dd/MM/yyyy") ? <span className="today"> Aujourd'hui : <b>{payment.datepayment}</b>  <br/></span> : "" }
                                                                        {payment.name==='total' ? <span className= {payment.datepayment === format(new Date(),"dd/MM/yyyy") ? "amounttoday" : ""}>{payment.amount} &euro;</span> :""}
                                                                        {payment.name==='total' ? <span> {payment.datepayment !== format(new Date(),"dd/MM/yyyy") ?  "le " + payment.datepayment : ""}</span> : ""}
                                                                    </li>:"")

                                                        }
                                                        <li className="info-detail"><span onClick={this.afficheDetailTab}>[{this.state.detailTab ? "-" : "+"}] Détail</span></li>
                                                        </ul>
                                                            {this.state.detailTab===true &&
                                                            <table className="table table-detail">
                                                                <thead>
                                                                <tr>
                                                                    <th scope="col">Date</th>
                                                                    <th scope="col">Montant</th>
                                                                    <th scope="col"></th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {   infoEtalementTab &&
                                                                    infoEtalementTab.map((payment, index) =>
                                                                        (payment.parent===this.state.parent ||  payment.name==='total')?
                                                                            <tr className ={(payment.datepayment === format(new Date(),"dd/MM/yyyy") ? "detail-contract-selected " : "") + (payment.name==='total' ? "tr-total" : "tr-detail")} key={index}>

                                                                                <td>{
                                                                                    payment.name==='total' ?
                                                                                        <span>{payment.datepayment === format(new Date(),"dd/MM/yyyy") ? "Aujourd'hui" : payment.datepayment}</span>
                                                                                        : payment.name
                                                                                }</td>
                                                                                <td><span>{payment.amount} &euro;</span></td>
                                                                                <td>{payment.name==='total' ? <button data-parent={payment.parent} onClick={this.viewList}>+</button> : ""} </td>
                                                                            </tr> : ""
                                                                    )

                                                                }
                                                                </tbody>
                                                            </table>
                                                            }
                                                        </div>

                                                    </div>

                                                }
                                                </div>

                                                <div id="btn-payment col-12">
                                                        { (((this.state.methodPayment==="piccb" || this.state.methodPayment==="picvir") || ((this.state.methodPayment==="pipcb" || this.state.methodPayment==="pipvir") && this.state.methodPaymentEtalement!=="")) && (this.state.errorMsgUpdateAmount==="")) &&
                                                            <>{
                                                                (this.state.methodPayment==="piccb" || this.state.methodPayment==="pipcb")&&
                                                                <button onClick={this.payment} className="ohm-btn-payment btn btn-customer-payment">Procéder au paiement</button>
                                                            }
                                                                {
                                                                    (this.state.methodPayment==="picvir" || this.state.methodPayment==="pipvir")&&
                                                                    <>
                                                                        {this.state.rechargePage===false &&
                                                                            <button onClick={this.transfer} className="ohm-btn-payment btn btn-customer-payment">Procéder au paiement</button>
                                                                        }
                                                                        {this.state.rechargePage===true &&
                                                                            <button onClick={this.reload} className="ohm-btn-payment btn btn-customer-payment">Actualiser la page</button>
                                                                        }
                                                                    </>
                                                                }
                                                                {this.state.loading===true &&
                                                                    <div className="col-12">
                                                                        <img className="loading" alt={"loading"}
                                                                             src={loading}/>
                                                                    </div>
                                                                }
                                                                {this.state.msgerrorurl!=="" &&
                                                                    <div className="msgerrorurl alert alert-danger" role="alert">
                                                                        {this.state.msgerrorurl}
                                                                    </div>
                                                                }
                                                            </>
                                                        }
                                                    </div>

                                                </div>

                                        }
                                        <div ref={key===0 ? this.blockRef0 : this.blockRef1}></div>
                                    </div>
                                </div>

                            </div>
                        )
                    })
                    }
                    <div className="col-12 info-contact" >
                        <span>Si vous rencontrez un problème contactez notre service client par téléphone au {this.state.telContact} (du lundi au vendredi 8:30 - 20:00 / le samedi : 9:00 - 14:00 / le dimanche : 9:00 - 13:00).</span>
                    </div>

                    <ReactModal
                        isOpen={this.state.isOpen}
                        contentLabel="Modal info carte"
                        className="custom-modal"
                    >
                        <div id="modal" className="content-modal">
                            <div className="close-modal">
                                <button onClick={this.closePopup} type="button" className=" btn-ohm btn btn-primary" aria-label="Close">X</button>
                            </div>
                            {this.state.loading===true &&
                            <div>
                                <img className="loading" alt={"loading"} src={loading}/>
                            </div>
                            }
                            <iframe  id="iframeWorldline" title={"Iframe Worldline"} src={"../iframeFile/iframecm.html?hostedTokenizationUrl="+this.state.hostedTokenizationUrl} allowFullScreen>
                            </iframe>

                        </div>

                    </ReactModal>

                    <ReactModal
                        isOpen={this.state.isUpdateDate}
                        contentLabel="Modal update date"
                        className="custom-modal-date"
                    >
                        <div id="modal-update-date" className="content-modal">
                            <div className="close-modal">
                                <button onClick={this.closePopupUpdateDate} type="button" className=" btn-ohm btn btn-primary" aria-label="Close">X</button>
                            </div>

                            <div className="container-info">
                                {this.state.updateDateStatus && (
                                    <Form
                                        onSubmit={this.handleActionUpdateDate}
                                        className={"form-info"}
                                        ref={c => {
                                            this.form = c;
                                        }}
                                    >
                                        <label htmlFor="par" style={{ color: "#30AD71" }}>
                                            <b>Modifier la date de prélevement</b>
                                        </label>
                                        <div className="form-group">
                                            <DatePicker
                                                selected={this.state.startDateUpdate}
                                                dateFormat="dd/MM/yyyy"
                                                onChange={handleDateUpdate}
                                                required
                                                className="form-control col-12 date-select"
                                                placeholderText="dd/mm/yyyy"
                                                filterDate={isWeekday}
                                                minDate={addDays(new Date(), 1)}
                                                maxDate={addDays(this.state.datePrel, this.state.nbrDaysUpdate)}
                                                locale="fr"
                                            />

                                            <button className="btn-ohm btn btn-primary btn-block" >Valider</button>
                                            {this.state.loading===true &&
                                                <img className="loading" alt={"loading"}
                                                     src={loading}/>
                                            }
                                        </div>
                                        <CheckButton
                                            style={{ display: "none" }}
                                            ref={c => {
                                                this.checkBtn = c;
                                            }}
                                        />

                                    </Form>)
                                }

                                {this.state.updateDateStatus===false && (
                                    <h3 className={this.state.classmessage}>{this.state.message}</h3>
                                )}
                            </div>

                        </div>

                    </ReactModal>

                </div>
                }
            </div>


        );

    }

}
